export default "__VITE_ASSET__0LdEFcxF__"